__turbopack_context__.v({
  "contentWrapper": "my-trips-module__5K4Wrq__contentWrapper",
  "upcomingTripsWrapper": "my-trips-module__5K4Wrq__upcomingTripsWrapper",
});
